import { render, staticRenderFns } from "./TelefoneSignatarioNovo.vue?vue&type=template&id=13786c25"
import script from "./TelefoneSignatarioNovo.vue?vue&type=script&lang=js"
export * from "./TelefoneSignatarioNovo.vue?vue&type=script&lang=js"
import style0 from "./TelefoneSignatarioNovo.vue?vue&type=style&index=0&id=13786c25&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports